import { SkeletonSectionType } from '../enums/skeleton-section-type.enum';

import styles from './SkeletonRow.module.scss';
import { SkeletonSection } from './SkeletonSection';

export const SkeletonRow = ({ rowItems }: { rowItems: SkeletonSectionType[] }) => {
  return (
    <div className={styles['row']}>
      {rowItems.map((type, index) => (
        <SkeletonSection key={`skeleton-section-${type}-${index}`} type={type} />
      ))}
    </div>
  );
};
